export default "__VITE_ASSET__mrtngWuQ__"